<template>
    <div v-if="loading" class="loading">
        <div class='loading_main'>
            <img src="@/assets/images/currency/icon_loading.gif">
            <div class="loading_text">{{message}}</div>
        </div>
    </div>
</template>

<script setup>
    import {
        ref
    } from 'vue'
    const loading = ref(false)
    const message = ref('')

    function open(values) {
        message.value = values
        loading.value = true
    }

    function close() {
        loading.value = false

    }
    defineExpose({
        open,
        close,
    });
</script>

<style scoped>
    .loading {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.3);
        z-index: 99;
        display: flex;
        justify-content: center;
        align-content: center;
    }

    .loading_main {
        position: absolute;
        top: 50%;
        text-align: center;
        margin-top: -22.5px;
    }

    .loading .loading_main img {
        width: 110px;
    }

    .loading .loading_main .loading_text {
        color: #ffffff;
        font-size: 13px;
        margin-top: 5px;
    }
</style>